import {
  ApplicationConfig,
  ErrorHandler,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter, Router, withComponentInputBinding } from '@angular/router';
import { GlobalErrorHandler, httpErrorInterceptor } from '@saexpeditions/sdk/errors';
import { authInterceptor, AUTH_SESSION_HANDLER } from '@saexpeditions/sdk/authentication';
import { API_BASE_URL } from '@saexpeditions/sdk/data';
import { routes } from './app.routes';

import { TokenSessionService } from '@core/services';
import { dmcOverrideInterceptor } from '@core/interceptors';
import { environment } from '@environments/environment';
import {
  provideRokitIcons,
  LUCIDE_ICONS,
  CUSTOM_ICONS,
  HEROICONS_ICONS,
  IONICONS_ICONS,
} from '@saexpeditions/sdk/web/icons';
import { provideLoader } from '@saexpeditions/sdk/web/loader';

export const appConfig: ApplicationConfig = {
  providers: [
    { provide: ErrorHandler, useClass: GlobalErrorHandler },
    { provide: API_BASE_URL, useValue: environment.apiUrl },
    {
      provide: AUTH_SESSION_HANDLER,
      useFactory: () => {
        const tokenSession = inject(TokenSessionService);
        const router = inject(Router);
        return {
          onSessionExpired: () => {
            tokenSession.clearSession();
            router.navigate(['/login']);
          },
        };
      },
    },
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withComponentInputBinding()),
    provideHttpClient(
      withInterceptors([httpErrorInterceptor, authInterceptor, dmcOverrideInterceptor]),
    ),
    provideRokitIcons({
      icons: { ...LUCIDE_ICONS, ...HEROICONS_ICONS, ...IONICONS_ICONS, ...CUSTOM_ICONS },
    }),
    provideLoader({
      spinnerImage: 'assets/images/loader/rokit-circle.png',
    }),
    provideAppInitializer(() => {
      const tokenSession = inject(TokenSessionService);
      return tokenSession.initialize();
    }),
  ],
};
